var _g, _circle, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarnings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_816_6619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3822 40.5535L25.6996 13.2646C27.331 10.1553 31.7678 10.1142 33.4564 13.1928L48.4246 40.4817C50.0336 43.415 47.9111 47 44.5655 47H15.2799C11.9702 47 9.84455 43.4843 11.3822 40.5535Z",
    fill: "#FFD445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5303 12.6512L10.2129 39.94C8.21394 43.7501 10.9773 48.3205 15.2799 48.3205H44.5655C48.9148 48.3205 51.674 43.66 49.5824 39.8466L34.6142 12.5578C32.4189 8.55557 26.6511 8.60897 24.5303 12.6512Z",
    stroke: "white",
    strokeWidth: 2.64093,
    strokeLinecap: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 38.5,
    r: 1.5,
    fill: "#F6F6F6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 22,
    width: 3,
    height: 13,
    rx: 1.5,
    fill: "#F6F6F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_816_6619",
    x: 0.227844,
    y: 0.267578,
    width: 59.3901,
    height: 57.373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_816_6619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_816_6619",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnings);
export default __webpack_public_path__ + "static/media/warnings.7a2001e32855edcb168dfadc011a2a11.svg";
export { ForwardRef as ReactComponent };